import { focus } from '@wkda/funnel-components';
import { assign, send } from 'xstate';
import { isFillInputEvent, isFocusInputEvent, isSelectEvent } from '../../machineModels/eventGenerators';
import { valueIsEmpty } from './guards';
export function focusOnEnterAction(_, __, _ref) {
  var _action$fieldName;

  let {
    action
  } = _ref;
  const stepName = (_action$fieldName = action.fieldName) !== null && _action$fieldName !== void 0 ? _action$fieldName : '';
  const domObject = document.querySelector("[name=\"" + stepName + "\"]");
  setTimeout(() => {
    if (domObject) {
      focus(domObject);
    }
  }, 0);
}
export const fillInputAction = assign((_ref2, evt, _ref3) => {
  let {
    values,
    selectedFields
  } = _ref2;
  let {
    action
  } = _ref3;

  if (!isFillInputEvent(evt)) {
    return {};
  }

  const {
    fieldName,
    selected
  } = evt;
  let newSelectedFields = { ...selectedFields
  };

  if (valueIsEmpty(selected)) {
    delete newSelectedFields[fieldName];
  } else {
    //@ts-expect-error
    const nextField = action.nextField;
    newSelectedFields[fieldName] = nextField;
  }

  return {
    values: { ...values,
      [fieldName]: selected
    },
    selectedFields: newSelectedFields,
    previousSelectedFieldsMap: reverseObject(newSelectedFields)
  };
});
export const assignOnPreloadAndClearAction = assign((_ref4, _, _ref5) => {
  var _action$fieldName2;

  let {
    preloadedData
  } = _ref4;
  let {
    action
  } = _ref5;
  //@ts-expect-error
  const stepToPreload = (_action$fieldName2 = action.fieldName) !== null && _action$fieldName2 !== void 0 ? _action$fieldName2 : '';
  const stepValueToPreload = preloadedData[stepToPreload];
  const updated = { ...preloadedData
  };
  delete updated[stepToPreload];
  return {
    stepToPreload,
    stepValueToPreload,
    preloadedData: { ...updated
    }
  };
});
export const selectWithPreloadedAction = send(_ref6 => {
  let {
    stepToPreload,
    stepValueToPreload
  } = _ref6;
  return {
    type: 'SELECT',
    selected: stepValueToPreload,
    fieldName: stepToPreload,
    selectionType: 'cache'
  };
});
export const assignDataOnSelectAction = assign((_ref7, event, _ref8) => {
  let {
    values,
    stack,
    selectedFields
  } = _ref7;
  let {
    action
  } = _ref8;

  if (!isSelectEvent(event)) {
    return {};
  }

  const {
    fieldName,
    selected
  } = event;
  const newSelectedFields = { ...selectedFields,
    //@ts-expect-error
    [fieldName]: action.nextField
  };
  return {
    values: { ...values,
      [fieldName]: selected
    },
    selectedFields: newSelectedFields,
    previousSelectedFieldsMap: reverseObject(newSelectedFields),
    updatingField: '',
    ...(stack.includes(fieldName) ? {} : {
      stack: stack.concat([fieldName]),
      prevStack: stack.concat([])
    })
  };
});
export const updateStackAction = assign((_ref9, _, _ref10) => {
  let {
    stack,
    prevStack,
    selectedFields
  } = _ref9;
  let {
    action
  } = _ref10;
  //@ts-expect-error
  const fieldName = action.fieldName; //@ts-expect-error

  const nextField = action.nextField;
  const isInStack = stack.includes(fieldName);
  const newSelectedFields = { ...selectedFields,
    [fieldName]: nextField
  };
  return {
    stack: !isInStack ? stack.concat(fieldName) : stack,
    prevStack: !isInStack ? stack.concat([]) : prevStack,
    selectedFields: newSelectedFields,
    previousSelectedFieldsMap: reverseObject(newSelectedFields)
  };
});
export const clearResetToAction = assign({
  resetTo: '',
  resetValue: '',
  resetType: '',
  stepToPreload: '',
  stepValueToPreload: ''
});
export const sendSelectAfterResetAction = send(_ref11 => {
  let {
    resetValue,
    resetTo,
    resetType
  } = _ref11;
  return {
    type: 'SELECT',
    selected: resetValue,
    fieldName: resetTo,
    selectionType: resetType
  };
}, //TODO: Remove this delay, we are not setting values in
//react effect anymore
{
  delay: 1
});
export const assignResetValuesAction = assign((_, event) => {
  if (isSelectEvent(event)) {
    return {
      resetTo: event.fieldName,
      resetValue: event.selected,
      resetType: event.selectionType
    };
  }

  return {};
});
export const resetValuesAndStackAction = assign((_ref12, _, _ref13) => {
  var _ctx$groupType;

  let {
    stack,
    resetTo,
    values,
    selectedFields,
    ...ctx
  } = _ref12;
  let {
    action
  } = _ref13;
  //@ts-expect-error
  const groupType = action.nodeType;
  const newStack = resetStackUntil(stack, resetTo);
  const fieldsGroup = (_ctx$groupType = ctx[groupType]) !== null && _ctx$groupType !== void 0 ? _ctx$groupType : [resetTo];
  const updatedValues = clearValues(values, resetTo, fieldsGroup, '');
  let nextSelectedFields = { ...selectedFields
  };

  if (groupType !== 'none') {
    clearSelectedFieldsForGroup(resetTo, nextSelectedFields);
  }

  return {
    stack: newStack,
    values: updatedValues,
    selectedFields: nextSelectedFields,
    previousSelectedFieldsMap: reverseObject(nextSelectedFields)
  };
});

function clearSelectedFieldsForGroup(initial, selectedFields) {
  let nextField = selectedFields[initial];

  while (nextField) {
    const next = selectedFields[nextField];
    delete selectedFields[nextField];
    nextField = next;
  }
}

export const selectFieldToFocusAction = assign((_, event) => {
  if (!isFocusInputEvent(event)) {
    return {};
  }

  return {
    updatingField: event.fieldName
  };
});
export const blurFieldAction = assign((_, event) => {
  if (event.type !== 'BLUR_INPUT') {
    return {};
  }

  return {
    updatingField: ''
  };
});
export const commitValuesAction = assign(_ref14 => {
  let {
    values
  } = _ref14;
  return {
    previousValues: { ...values
    }
  };
});

function resetStackUntil(stack, step) {
  const indexOfStep = stack.indexOf(step);

  if (indexOfStep < 0) {
    return stack;
  }

  return stack.slice(0, indexOfStep);
}

function clearValues(values, step, orderedSteps, defaultValue) {
  const indexOfStep = orderedSteps.indexOf(step);

  if (indexOfStep < 0 || indexOfStep >= orderedSteps.length) {
    return values;
  }

  const otherValues = Object.entries(values).reduce(function sReducer(acc, _ref15) {
    let [key, value] = _ref15;

    if (!orderedSteps.includes(key)) {
      //@ts-expect-error
      acc[key] = value;
    }

    return acc;
  }, {});
  const stepsToKeep = orderedSteps.slice(0, indexOfStep);
  const newValues = Object.entries(values).reduce(function reducer(acc, _ref16) {
    let [key, value] = _ref16;

    if (stepsToKeep.includes(key)) {
      //@ts-expect-error
      acc[key] = value;
    } else {
      //@ts-expect-error
      acc[key] = defaultValue;
    }

    return acc;
  }, {});
  return { ...newValues,
    ...otherValues
  };
}

function reverseObject(obj) {
  const inverse = {};

  for (const item of Object.entries(obj)) {
    inverse[item[1]] = item[0];
  }

  return inverse;
}